import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicFlight({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8.94 4.8c.88-.95 1.65-1.72 2.38-2.38.58-.58 1.28-.93 1.88-.92l.18.01c.3.04.56.16.76.35.23.24.35.57.36.94 0 .6-.34 1.3-.9 1.87-.68.74-1.45 1.5-2.4 2.39l1.27 6.33a.5.5 0 01-.26.54l-.7.35a.5.5 0 01-.67-.23L8.62 9.6l-2.87 2.43c.11.38.17.7.16.98-.02.53-.3.89-.84.89-.24 0-.46-.07-.72-.26l-2.03-2.03a1.14 1.14 0 01-.22-.68c0-.54.36-.82.89-.84.28-.01.6.05.98.16L6.4 7.38 1.95 5.16a.5.5 0 01-.23-.68l.35-.69a.5.5 0 01.54-.26l6.33 1.26z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicFlight.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicFlight.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicFlight svgRef={ref} {...props} />);
export default ForwardRef;
